export { LoginComponent } from './login/login.component';
export { SSOLoginComponent } from './ssologin/ssologin.component';
export { StatusReportComponent } from './statusReport/statusReport';
export { ExperienceReportComponent } from './experienceReport/experienceReport';
export { VideoDetailsComponent } from './experienceReport/videoDetails';
export { DashboardHome } from './dashboard/dashboard.home';



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/viewsmodule/views.ts